export enum ReportDistribution {
  Day = "day",
  Hour = "hour",
  Month = "month",
}
